module.exports = __webpack_public_path__ + "static/Artboard-7-a32ce9823bdc0a5bb584faaabd5f79a9.png";